import Reactivation from 'features/reactivation/Reactivation';
import React from 'react';

export default function ReactivationPage() {
  return <Reactivation />;
}
